module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/extreme-networks.7404ff1c.png";